module.exports = __webpack_public_path__ + "img/medicos.46c33dbb.png";